/**
 * Impulse PDP gallery: desktop shows one image (Dawn is-active swap), arrows + thumbs navigate.
 */
(function () {
  if (!document.documentElement.classList.contains('header-layout--impulse')) return;

  const DESKTOP_MQL = window.matchMedia('(min-width: 750px)');

  function scrollThumbnailIntoView(thumbnailsComponent, thumbnail) {
    if (!thumbnailsComponent || !thumbnail) return;
    const list = thumbnailsComponent.querySelector('[id^="Slider-Thumbnails"]');
    if (!list) return;

    if (DESKTOP_MQL.matches) {
      const top =
        thumbnail.offsetTop - list.clientHeight / 2 + thumbnail.clientHeight / 2;
      list.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    } else {
      list.scrollTo({ left: thumbnail.offsetLeft, behavior: 'smooth' });
    }
  }

  function getSlides(viewer) {
    return Array.from(viewer.querySelectorAll('.product__media-item[data-media-id]'));
  }

  /**
   * Mobile only: pontos indicativos (estilo Instagram) sob a imagem principal.
   * Mostram que existem mais imagens e que se pode arrastar para o lado.
   */
  function setupMobileDots(mediaGallery, viewer) {
    const slides = getSlides(viewer);
    if (slides.length < 2) return;

    const list = viewer.querySelector('.product__media-list');
    if (!list) return;

    let dots = viewer.querySelector('.product__media-dots');
    if (!dots) {
      dots = document.createElement('div');
      dots.className = 'product__media-dots';
      dots.setAttribute('role', 'tablist');
      dots.setAttribute('aria-label', 'Imagens do produto');

      slides.forEach((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product__media-dot';
        dot.setAttribute('aria-label', `Ver imagem ${index + 1}`);
        dot.addEventListener('click', () => {
          list.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(dot);
      });

      viewer.appendChild(dots);
    }

    const dotEls = Array.from(dots.children);

    function updateActiveDot() {
      const slideWidth = slides[0].offsetWidth || list.clientWidth || 1;
      const index = Math.min(slides.length - 1, Math.round(list.scrollLeft / slideWidth));
      dotEls.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }

    if (!list.dataset.impulseDotsBound) {
      list.dataset.impulseDotsBound = 'true';
      let rafId = null;
      list.addEventListener(
        'scroll',
        () => {
          if (rafId) return;
          rafId = window.requestAnimationFrame(() => {
            rafId = null;
            updateActiveDot();
          });
        },
        { passive: true }
      );
    }

    updateActiveDot();
  }

  /**
   * Lightbox/galeria em ecrã inteiro: clicar numa imagem abre todas as imagens
   * num overlay que ocupa a página, com swipe e um X no canto superior direito.
   */
  function setupLightbox(mediaGallery, viewer) {
    const slides = getSlides(viewer);
    if (!slides.length) return;

    let overlay = null;
    let track = null;

    function buildOverlay() {
      overlay = document.createElement('div');
      overlay.className = 'impulse-lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Galeria de imagens');
      overlay.hidden = true;

      const closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'impulse-lightbox__close';
      closeBtn.setAttribute('aria-label', 'Fechar galeria');
      closeBtn.innerHTML =
        '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      closeBtn.addEventListener('click', closeLightbox);

      track = document.createElement('div');
      track.className = 'impulse-lightbox__track';

      getSlides(viewer).forEach((slide) => {
        const sourceImg = slide.querySelector('img');
        if (!sourceImg) return;
        const figure = document.createElement('div');
        figure.className = 'impulse-lightbox__slide';
        const img = sourceImg.cloneNode(true);
        img.removeAttribute('loading');
        img.removeAttribute('class');
        img.style.removeProperty('width');
        img.style.removeProperty('height');
        figure.appendChild(img);
        track.appendChild(figure);
      });

      track.addEventListener('click', (event) => {
        if (event.target === track) closeLightbox();
      });

      overlay.appendChild(closeBtn);
      overlay.appendChild(track);
      document.body.appendChild(overlay);
    }

    function openLightbox(index) {
      if (overlay) overlay.remove();
      buildOverlay();
      if (!track) return;

      overlay.hidden = false;
      document.documentElement.classList.add('impulse-lightbox-open');

      const target = track.children[index] || track.children[0];
      if (target) {
        track.scrollTo({ left: target.offsetLeft, behavior: 'auto' });
      }

      document.addEventListener('keydown', onKeydown);
    }

    function closeLightbox() {
      if (!overlay) return;
      overlay.hidden = true;
      document.documentElement.classList.remove('impulse-lightbox-open');
      document.removeEventListener('keydown', onKeydown);
    }

    function onKeydown(event) {
      if (event.key === 'Escape') closeLightbox();
    }

    if (!viewer.dataset.impulseLightboxDelegate) {
      viewer.dataset.impulseLightboxDelegate = 'true';
      viewer.addEventListener('click', (event) => {
        const slide = event.target.closest('.product__media-item');
        if (!slide || !viewer.contains(slide)) return;
        if (event.target.closest('a, button:not(.product__media-toggle)')) return;
        event.preventDefault();
        const currentSlides = getSlides(viewer);
        openLightbox(currentSlides.indexOf(slide));
      });
    }

    getSlides(viewer).forEach((slide) => {
      const container = slide.querySelector('.product-media-container') || slide;
      container.classList.add('impulse-zoomable');
    });
  }

  function clearDesktopTrackStyles(viewer) {
    const list = viewer.querySelector('.product__media-list');
    if (!list) return;

    list.scrollLeft = 0;
    list.style.removeProperty('width');
    list.style.removeProperty('transform');

    getSlides(viewer).forEach((slide) => {
      slide.style.removeProperty('flex-basis');
      slide.style.removeProperty('width');
      slide.style.removeProperty('min-width');
      slide.style.removeProperty('max-width');
    });
  }

  function syncThumbnailState(thumbnailsComponent, mediaId) {
    if (!thumbnailsComponent || !mediaId) return;

    const activeThumbnail = thumbnailsComponent.querySelector(`[data-target="${mediaId}"]`);
    thumbnailsComponent.querySelectorAll('button').forEach((btn) => {
      btn.removeAttribute('aria-current');
    });
    activeThumbnail?.querySelector('button')?.setAttribute('aria-current', 'true');
    scrollThumbnailIntoView(thumbnailsComponent, activeThumbnail);
  }

  function initMediaGallery(mediaGallery) {
    if (mediaGallery.dataset.impulseGalleryInit === 'true') return;
    mediaGallery.dataset.impulseGalleryInit = 'true';

    const viewer = mediaGallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    mediaGallery.classList.add('impulse-gallery--slide');

    const sliderControls = viewer.querySelector('.slider-buttons');
    const thumbnailsComponent = mediaGallery.querySelector('[id^="GalleryThumbnails"]');

    function replaceNavButton(button) {
      if (!button?.parentNode) return null;
      const clone = button.cloneNode(true);
      button.parentNode.replaceChild(clone, button);
      clone.removeAttribute('disabled');
      return clone;
    }

    if (sliderControls) {
      sliderControls.querySelectorAll('button[name="previous"], button[name="next"]').forEach(replaceNavButton);
    }

    const prevNavBtn = sliderControls?.querySelector('button[name="previous"]');
    const nextNavBtn = sliderControls?.querySelector('button[name="next"]');

    function syncNavButtonState() {
      if (!DESKTOP_MQL.matches) {
        prevNavBtn?.removeAttribute('disabled');
        nextNavBtn?.removeAttribute('disabled');
        return;
      }

      const slides = getSlides(viewer);
      const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      prevNavBtn?.toggleAttribute('disabled', activeIndex <= 0);
      nextNavBtn?.toggleAttribute('disabled', activeIndex < 0 || activeIndex >= slides.length - 1);
    }

    const originalSetActiveMedia = mediaGallery.setActiveMedia?.bind(mediaGallery);

    function activateMedia(mediaId, prepend) {
      if (!mediaId) return;

      const slides = getSlides(viewer);
      const activeMedia =
        viewer.querySelector(`[data-media-id="${mediaId}"]`) || slides[0];
      if (!activeMedia) return;

      if (prepend) {
        if (activeMedia.parentElement.firstElementChild !== activeMedia) {
          activeMedia.parentElement.prepend(activeMedia);
        }
        const activeThumbnail = thumbnailsComponent?.querySelector(`[data-target="${mediaId}"]`);
        if (activeThumbnail && activeThumbnail.parentElement.firstElementChild !== activeThumbnail) {
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
      }

      if (DESKTOP_MQL.matches) {
        clearDesktopTrackStyles(viewer);

        getSlides(viewer).forEach((slide) => {
          slide.classList.remove('is-active');
          slide.classList.remove('scroll-trigger--cancel');
        });
        activeMedia.classList.add('is-active');
        activeMedia.classList.add('scroll-trigger--cancel');

        if (typeof mediaGallery.playActiveMedia === 'function') {
          mediaGallery.playActiveMedia(activeMedia);
        }

        syncThumbnailState(thumbnailsComponent, mediaId);
        syncNavButtonState();
        return;
      }

      if (originalSetActiveMedia) {
        originalSetActiveMedia(mediaId, prepend);
      }

      syncNavButtonState();
    }

    mediaGallery.setActiveMedia = function (mediaId, prepend) {
      activateMedia(mediaId, prepend);
    };

    function bindThumbnailButtons() {
      if (!thumbnailsComponent || thumbnailsComponent.dataset.impulseThumbDelegate === 'true') return;
      thumbnailsComponent.dataset.impulseThumbDelegate = 'true';
      thumbnailsComponent.addEventListener('click', (event) => {
        const button = event.target.closest('button.thumbnail');
        const thumb = button?.closest('[data-target]');
        if (!thumb) return;
        event.preventDefault();
        event.stopPropagation();
        activateMedia(thumb.dataset.target, false);
      });
    }

    bindThumbnailButtons();

    clearDesktopTrackStyles(viewer);

    const slides = getSlides(viewer);
    if (DESKTOP_MQL.matches && slides.length) {
      const active =
        slides.find((slide) => slide.classList.contains('is-active')) || slides[0];
      slides.forEach((slide) => {
        slide.classList.toggle('is-active', slide === active);
        slide.classList.toggle('scroll-trigger--cancel', slide === active);
      });
    }

    syncNavButtonState();

    setupMobileDots(mediaGallery, viewer);
    setupLightbox(mediaGallery, viewer);

    function navigate(delta) {
      if (!DESKTOP_MQL.matches) return;

      const slideList = getSlides(viewer);
      if (slideList.length < 2) return;

      const currentIndex = slideList.findIndex((slide) => slide.classList.contains('is-active'));
      const safeIndex = currentIndex >= 0 ? currentIndex : 0;
      const nextIndex = Math.max(0, Math.min(safeIndex + delta, slideList.length - 1));
      const nextMediaId = slideList[nextIndex].dataset.mediaId;

      if (nextMediaId) activateMedia(nextMediaId, false);
    }

    function onDesktopNav(event) {
      const button = event.target.closest('button[name="previous"], button[name="next"]');
      if (!button || button.disabled) return;

      event.preventDefault();
      event.stopPropagation();
      navigate(button.name === 'next' ? 1 : -1);
    }

    sliderControls?.addEventListener('click', onDesktopNav);

    DESKTOP_MQL.addEventListener('change', () => {
      clearDesktopTrackStyles(viewer);
      syncNavButtonState();
    });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(initMediaGallery);
  }

  function bootstrap() {
    if (customElements.get('media-gallery')) {
      init();
    } else {
      customElements.whenDefined('media-gallery').then(init);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('media-gallery')?.forEach(initMediaGallery);
    if (event.target.matches?.('media-gallery')) initMediaGallery(event.target);
  });
})();
